module.exports = JSON.parse('{"languageSwitcher":{"label":"Тіл"},"close":"Жабу","pageTitle":"Жаңа жыл 2027 — Артығы жоқ! | NL International"}')